export const DEFAULT_I18N_CONFIG = {
  currency: '₹',
  currency_iso: 'INR',
  locale: 'en-US',
};
